export class SendLetterConstants {
    static SELECT_TEMPLATE_LABEL = "Select template";
    static COMMUNICATION_MECHANISM_LABEL = "Communication mechanism";
    static DOWNLOAD_RECIPIENTS_BTN_LABEL = "Download recipients";
    static DOWNLOAD_DOCUMENTS_BTN_LABEL = "Download document";
    static COMPONENT_NAME = "SendLetterComponent";
    static ATTACHMENT_MANAGER_CONTROL = "attachmentManager";
    static HEADERS_FOR_CSV = ["Application Ref No", "Name", "Surname", "ID Number", "Organisation", "Designation", "Telephone", "Homephone", "Cellphone", "Fax", "Email", "Street Address", "Street Address Suburb", "Street Address City", "Street Address Province", "Street Address Code", "Postal Address", "Postal Address Suburb", "Postal Address City", "Postal Address Province", "Postal Address Code"];
    static COMM_MECH_CONTROL = "communicationMechanism";
    static NO_RECIPIENT_ERR_MSG = "Please add or select a recipient.";
    static NO_TEMPLATE_ERR_MSG = "Please select a template to download";
    static NO_COMM_MECHANISM_ERR_MSG = "Please select the post method";
    static NO_ATTACHMENT = "Template has no attachment";
    static SEND_LETTER_ERR_OBJ = "sendLetter";
    static EMAIL_FIELD_PLACEHOLDER = "emailField";
}
